import "../gdn-responsive-layout-1.css";
import GdnAdTemplate from "../GdnAdTemplate";

interface GdnResponsive1200x1200AdsProps {
  id: string;
  zoom: number;
}

/** Google Display Network responsive square format from Figma layout 1. */
const GdnResponsive1200x1200Ads = ({id, zoom}: GdnResponsive1200x1200AdsProps) => (
  <GdnAdTemplate
    id={id}
    zoom={zoom}
    variant="stacked"
    layoutVariants={{2: "responsive-horizontal", 3: "responsive-horizontal"}}
    showContent={false}
    defaultTransform={{x: 0, y: -720, scale: 1}}
  />
);

export default GdnResponsive1200x1200Ads;
